import {_, classNames, React, ReactDOM,utils, useMemo, Fragment} from '@api';
import {Icon} from '@blueprintjs/core';
import {ui, LibraryItemConfigWrapper} from '@stores'
import {action, computed, observable, reaction, runInAction} from 'mobx';
import {observer} from 'mobx-react';
import scrollIntoView from 'scroll-into-view-if-needed';
import {FilterCheckbox, FilterGroupUIStore} from './'
import * as css from './FilterGroupMore.css';
import {FILTER_UNASSIGNED_ID, filterCompareFn, FilterItemState, LoadingIndicator, FilterItemDefinition, SimpleFilterItemDefinition} from '@design-board'

interface FilterGroupMoreProps {
  title?: React.ReactNode
  displayName: string
  group?: string
  onClose?: () => void
  items?: Array<FilterItemDefinition>
  selected?: Map<string, FilterItemState>
  excluded?: Map<string, FilterItemState>
  grouped?: any
  library?: LibraryItemConfigWrapper
  store: FilterGroupUIStore
}
// TODO: make this a hooks compatible like FilterGroupItems
@observer
export class FilterGroupMore extends React.Component<FilterGroupMoreProps> {
  @observable data: Array<any> = []
  constructor(props) {
    super(props)
    this.loadData()
  }

  @computed get groupItems() {
    return this.filterGroup.items
  }

  @computed get items() {
    const {groupItems: items, props: {grouped, group}, data, filter} = this,
      {state: {groups}} = filter
    if (data?.length) {
      const d = data.map(d => ({...d, compoundId: d.id.toString(), name: d?.name?.toString() ?? d?.id?.toString()}))
      return d
    }
    return data?.length ? data.map(d => ({...d, compoundId: d.id.toString(), name: d?.name?.toString() ?? d?.id?.toString()})) : items ? items : _.keys(grouped).sort(filterCompareFn).map(k => ({ name: k?.toString() || '', compoundId: k.toString(), id: k || '',  count: grouped[k].length, type: group}) as FilterItemDefinition)
  }

  @computed get filter() {
    return this.props.store.filter
  }

  @observable loading = true

  @action loadData = async () => {
    this.loading = true
    const r = await this.filter.loadMoreData(this.props.group, this.props.library)

    runInAction(() => {
      this.data = r?.data
      this.loading = false
    })
  }

  @computed get filteredItems() {
    let {items, searchText, catalog: {labelFor}} = this

    if (searchText != null && searchText != '') {
      searchText = searchText.toLowerCase()

      items = items.filter(item => labelFor(item).toString().toLowerCase().indexOf(searchText) != -1)
    }

    return items
  }

  get catalog() { return this.filter.catalog}

  @computed get letterToItems() {
    const {filteredItems, catalog: {labelFor}} = this
    return _.groupBy(filteredItems, i => {
      let v       = (labelFor(i) || '').toString().substring(0, 1).toUpperCase()
      const regex = /^[0-9a-zA-Z]+$/
      return v != ' ' && v.match(regex) ? v : '#'
    })
  }

  componentWillUnmount(): void {
    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  @action onToggle = (id, item) => () => {
    const {props: {group}, filter} = this
    filter.toggleFilterBatched({key: group, value: item.compoundId ?? item.id, item, exclude: false})
    // filter.toggleFilter({key: group, value: id, item})
  }

  @observable mousedOverChar = null

  @computed get filterGroup() {
    const {props: {group}, filter} = this
    return filter.state.groups[group]
  }

  render() {
    const {catalog: {labelFor}, _letterRefs, loading, props: {group, grouped, title, displayName, onClose, selected}, letterToItems, mousedOverChar, searchText, onToggle, filterGroup, filter: {strings}} = this
    //console.log(group, grouped, this.items, letterToItems)
    let aAsciiCode = 'A'.charCodeAt(0)

    return <div className={css.filterGroupMore} data-loading={loading}>
      <div className={css.titleBar}>
        <input className={css.searchInput} placeholder={`Search ${title}`} onChange={this.onChangeSearch}/>
        <ul>
          <li className={classNames(!letterToItems['#'] && css.disabled)}
              key='other'
              onClick={() => this.onClickLetter('#')}
              onMouseEnter={() => this.mousedOverChar = '#'}
              onMouseLeave={() => this.mousedOverChar = null}
          >#
          </li>
          {_.range(aAsciiCode, aAsciiCode + 26).map((code, i) => {
            let char = String.fromCharCode(code)
            return <li key={i}
                       onClick={() => this.onClickLetter(char)}
                       onMouseEnter={() => this.mousedOverChar = char}
                       onMouseLeave={() => this.mousedOverChar = null}
                       className={classNames(_.isEmpty(letterToItems[char]) && css.disabled)}>
              {char}
            </li>
          })}
        </ul>
        <Icon className={css.closeIcon} icon='cross' onClick={onClose}/>
      </div>
      <div className={css.details}>
        {loading && <LoadingIndicator />}
        <ul className={css.list}>
          {Object.keys(letterToItems).sort().map((l, i) => {
            let dimmed = mousedOverChar != null && l != mousedOverChar
            return <Fragment key={l}>
              <li ref={r => _letterRefs[l] = r} key={i} className={classNames(css.title, dimmed && css.dimmed)}>{l}</li>

              {letterToItems[l].map((item: SimpleFilterItemDefinition, j) => {
                let name = labelFor(item) //getName(item)
                let count = 0
                if(filterGroup.def) {
                  count = item.count || (grouped && grouped[name] && _.isArray(grouped[name]) ? grouped[name].length : 0)
                } else {
                  count = item.count
                }

                // YFTS-3196, YFTS-3234 Because we no longer know the # of items associated with the tag
                if (count == 0 && group == 'tag') {
                  count = null
                }

                if (count == 0 && group == '')
                name = (filterGroup.def || _.includes(['tag'], group) && name == FILTER_UNASSIGNED_ID) ? 'None' : name
                //item[colorWayConfig.customAttributeType[item.customAttributeDefinition && item.customAttributeDefinition.type]]) || (item.name.toLowerCase().endsWith('unassigned') && selected.has(group === 'customAttribute' ? item.name : 'unassigned'))}
                return <li className={classNames(css.filterItem, dimmed && css.dimmed)} data-id={item.compoundId ?? item.id} key={j}>
                  <FilterCheckbox
                    name={utils.isEmptyString(name) ? strings.noValue : name}
                    checked={selected.has((item.compoundId ?? item.id).toString())}
                    count={count}
                    group={group}
                    item={item}
                    //showIcon={productField != null && !filterGroup.def && !_.includes(['tag'], group)}
                    displayName={displayName}
                    onChange={onToggle(item.compoundId ?? item.id, item)}
                    search={searchText} />
                </li>})}
            </Fragment>
          })}
        </ul>
      </div>
    </div>
  }

  _letterRefs : { [letter: string]: React.ReactInstance } = {}

  @action onClickLetter = (char: string) => {
    const {letterToItems, _letterRefs, props: {}} = this;
    const items                      = letterToItems[char]
    var ref = _letterRefs[char]
    if (ref) {
      var element = ReactDOM.findDOMNode(ref) as Element
      //element.scrollIntoView({block: 'start'})
      scrollIntoView(element, { behavior: 'smooth', inline: 'center', block: 'center',})
    }
  }

  @observable searchText : string
  @action onChangeSearch = (e) => { this.searchText = e.target.value }
}



// WEBPACK FOOTER //
// ./src/modules/catalog/internal/filters/components/internal/FilterGroupMore.tsx